import { createIcon, Svg } from "@gluestack-ui/icon";
import { Rect } from "react-native-svg";

const PatchIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 21 21",
  path: (
    <>
      <Rect
        x="1.1"
        y="1.1"
        width="18.8"
        height="18.8"
        rx="4.9"
        fill="none"
        stroke-width="2.2"
      />
    </>
  ),
});

PatchIcon.displayName = "PatchIcon";
export { PatchIcon };
